import { callAppAPI, gererRedirectSecuriteFor401 } from "./AppApiClient";
import {DictionnaireApi} from "./DictionnaireApi";
import { AdminService } from "src/domain/AdminService";
import { AxiosError } from "axios";
import { AdminAccessGroup } from "src/domain/AdminAccessGroup";
import { AdminPublicite } from "src/domain/AdminPublicite";

export const adminGetServices = async () : Promise<AdminService[]> => {
  return callAppAPI<AdminService[]>({
    method: "GET",
    url: DictionnaireApi.adminGetServices.getUrl(),
  })
    .then(result => {
      return result;
    }).catch((error : AxiosError) => {
      gererRedirectSecuriteFor401(error);
    });
};

export const adminSetService = async (values: AdminService) => {
  return callAppAPI<void>({
    method: "PUT",
    url: DictionnaireApi.adminSetService.getUrl(values.id),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const adminCreateService = async (values: AdminService) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.adminSetService.getUrl(values.id),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const adminDeleteeService = async (values: AdminService) => {
  return callAppAPI<void>({
    method: "DELETE",
    url: DictionnaireApi.adminSetService.getUrl(values.id),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const adminGetPublicites = async () : Promise<AdminPublicite[]> => {
  return callAppAPI<AdminPublicite[]>({
    method: "GET",
    url: DictionnaireApi.adminGetPublicites.getUrl(),
  })
    .then(result => {
      return result;
    }).catch((error : AxiosError) => {
      gererRedirectSecuriteFor401(error);
    });
};

export const adminDeletePublicite = async (values: AdminPublicite) => {
  return callAppAPI<void>({
    method: "DELETE",
    url: DictionnaireApi.adminSetPublicites.getUrl(values.id),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const adminSetPublicite = async (values: AdminPublicite) => {
  return callAppAPI<void>({
    method: "PUT",
    url: DictionnaireApi.adminSetPublicites.getUrl(values.id),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const adminCreatePublicite = async (values: AdminPublicite) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.adminSetPublicites.getUrl(values.id),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const adminGetAccessGroups = async () : Promise<AdminAccessGroup[]> => {
  return callAppAPI<AdminService[]>({
    method: "GET",
    url: DictionnaireApi.adminGetAccessGroups.getUrl(),
  })
    .then(result => {

      return result;
    }).catch((error : AxiosError) => {
      gererRedirectSecuriteFor401(error);
    });
};



export const adminSetAccessGroup= async (values: AdminAccessGroup) => {
  return callAppAPI<void>({
    method: "PUT",
    url: DictionnaireApi.adminSetAccessGroups.getUrl(''+values.id),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const adminCreateAccessGroup= async (values: AdminAccessGroup) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.adminCreateAccessGroups.getUrl(),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const adminDeleteAccessGroup= async (values: AdminAccessGroup) => {
  return callAppAPI<void>({
    method: "DELETE",
    url: DictionnaireApi.adminSetAccessGroups.getUrl(''+values.id),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};
